import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  let mapIllu = document.querySelector('.illu--map');
  let treesIllu = document.querySelector('.illu--trees');

  if (mapIllu) {
    let mapLandMark = mapIllu.querySelector('#landmark')
    let mapName = mapIllu.querySelector('#name')
    let mapIlluTimeline = gsap.timeline();

    mapIlluTimeline.set(mapLandMark, { scale: 0, transformOrigin: 'bottom center' })
    mapIlluTimeline.set(mapName, { x: "+=120" })

    ScrollTrigger.create({
      trigger: mapIllu,
      start: 'center center',
      onEnter: () => {

        mapIlluTimeline.add(
          'map-animation-start'
        ).to(
          mapLandMark, {
            scale: 1.5,
            transformOrigin: 'bottom center',
            duration: .25,
            ease: 'power2.out'
          }
        ).to(
          mapLandMark, {
            scale: 1,
            transformOrigin: 'bottom center',
            duration: .15,
            ease: 'power2.inout'
          }
        ).to(
          mapName, {
            x: "0"
          },
          'map-animation-start'
        )
      }
    })
  }

  if (treesIllu) {
    let treesIlluTree1 = treesIllu.querySelector('#tree-01')
    let treesIlluTree2 = treesIllu.querySelector('#tree-02')
    let treesIlluTree3 = treesIllu.querySelector('#tree-03')
    let treesIlluTimeline = gsap.timeline();

    treesIlluTimeline.set(treesIlluTree1, { scale: 0, transformOrigin: 'bottom center' })
    treesIlluTimeline.set(treesIlluTree2, { scale: 0, transformOrigin: 'bottom center' })
    treesIlluTimeline.set(treesIlluTree3, { scale: 0, transformOrigin: 'bottom center' })

    ScrollTrigger.create({
      trigger: treesIllu,
      start: 'center 75%',
      onEnter: () => {

        treesIlluTimeline.add(
          'trees-animation-start'
        ).to(
          treesIlluTree1, {
            scale: 1,
            transformOrigin: 'bottom center',
            duration: .65,
            ease: 'power2.out',
          }
        ).to(
          treesIlluTree2, {
            scale: 1,
            transformOrigin: 'bottom center',
            duration: .65,
            ease: 'power2.out',
            delay: .4,
          }, 'trees-animation-start'
        ).to(
          treesIlluTree3, {
            scale: 1,
            transformOrigin: 'bottom center',
            duration: .65,
            ease: 'power2.out',
            delay: .8,
          }, 'trees-animation-start'
        )
      }
    })
  }

});

